var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarPrice = function SvgCarPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11.25C23.2497 10.2895 22.8681 9.36832 22.189 8.689L20.25 6.75H3.75L1.811 8.689C1.13191 9.36832 0.750294 10.2895 0.75 11.25C0.75 11.6478 0.908035 12.0294 1.18934 12.3107C1.47064 12.592 1.85218 12.75 2.25 12.75H8.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07495 9.75H5.24995",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9251 9.75H21.0371",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2776 14H15.2446C14.9331 14.0002 14.6313 14.1088 14.391 14.3072C14.1508 14.5056 13.9871 14.7814 13.928 15.0873C13.8688 15.3932 13.918 15.7102 14.067 15.9838C14.216 16.2574 14.4556 16.4707 14.7446 16.587L16.8086 17.412C17.0983 17.5279 17.3386 17.7411 17.4881 18.015C17.6376 18.2888 17.687 18.6062 17.6278 18.9126C17.5686 19.2189 17.4046 19.4951 17.1638 19.6935C16.923 19.892 16.6206 20.0004 16.3086 20H14.2776",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7776 14.004V13.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7776 20.75V20.004",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7776 23C19.0913 23 21.7776 20.3137 21.7776 17C21.7776 13.6863 19.0913 11 15.7776 11C12.4639 11 9.77759 13.6863 9.77759 17C9.77759 20.3137 12.4639 23 15.7776 23Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75L5.45 2.21C5.61083 1.7807 5.89902 1.4108 6.27595 1.14986C6.65288 0.888918 7.10056 0.749402 7.559 0.750002H16.441C16.8989 0.750014 17.3459 0.889814 17.7223 1.15071C18.0986 1.41161 18.3863 1.78118 18.547 2.21L20.247 6.75H3.75Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75C4.14782 15.75 4.52936 15.592 4.81066 15.3107C5.09196 15.0294 5.25 14.6478 5.25 14.25V12.75H2.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCarPrice;